import styled from 'styled-components';

export const CardsContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: -8px;
`;
